var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchAwsThinkboxXMesh32(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-Architecture/32/Arch_AWS-ThinkBox-XMesh_32") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "100%",
    y2: "0%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8511B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Architecture/32/Arch_AWS-ThinkBox-XMesh_32",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle",
    fill: "url(#linearGradient-1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon-Service/32/AWS-ThinkBox-XMesh_32",
    transform: "translate(4.000000, 4.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.715,16.58 L19.558,17.851 L25.757,21.571 C25.907,21.661 25.999,21.823 26,21.998 L26,24.615 L28,23.238 L28,20.286 L21.715,16.58 Z M15.754,19.232 L25,24.689 L25.001,22.284 L18.429,18.34 C18.304,18.306 18.196,18.224 18.131,18.112 C18.015,17.915 18.037,17.647 18.2,17.487 C18.271,17.416 18.357,17.368 18.447,17.345 L27.56,11.974 L25.486,10.591 L5.757,22.429 C5.678,22.476 5.589,22.5 5.5,22.5 C5.403,22.5 5.307,22.472 5.223,22.416 L3,20.934 L3,23.238 L5.507,24.974 L15.246,19.232 C15.403,19.14 15.598,19.14 15.754,19.232 L15.754,19.232 Z M9.285,15.419 L11.442,14.148 L5.243,10.429 C5.093,10.339 5.001,10.177 5,10.002 L4.989,7.385 L3,8.762 L3,11.714 L9.285,15.419 Z M15.246,12.767 L5.989,7.31 L5.999,9.716 L12.677,13.724 C12.828,13.814 12.921,13.978 12.92,14.154 C12.919,14.33 12.826,14.494 12.674,14.583 L3.441,20.026 L5.514,21.409 L25.243,9.571 C25.408,9.471 25.616,9.476 25.777,9.584 L28,11.066 L28,8.762 L25.493,7.026 L15.754,12.767 C15.598,12.86 15.403,12.86 15.246,12.767 L15.246,12.767 Z M28.754,12.431 L22.699,16 L28.754,19.569 C28.906,19.659 29,19.823 29,20 L29,23.5 C29,23.664 28.92,23.818 28.784,23.911 L25.799,25.978 C25.714,26.037 25.614,26.067 25.515,26.067 C25.427,26.067 25.339,26.044 25.261,25.997 L15.5,20.244 L5.739,25.997 C5.573,26.097 5.361,26.089 5.201,25.978 L2.216,23.911 C2.08,23.818 2,23.664 2,23.5 L2,20 C2,19.823 2.094,19.659 2.246,19.569 L8.301,16 L2.246,12.431 C2.094,12.341 2,12.177 2,12 L2,8.5 C2,8.336 2.08,8.182 2.216,8.089 L5.201,6.022 C5.361,5.911 5.573,5.903 5.739,6.002 L15.5,11.756 L25.261,6.002 C25.427,5.903 25.639,5.911 25.799,6.022 L28.784,8.089 C28.92,8.182 29,8.336 29,8.5 L29,12 C29,12.177 28.906,12.341 28.754,12.431 L28.754,12.431 Z M18,27.232 L15.5,28.899 L13.402,27.5 L15.778,25.916 C15.916,25.823 16,25.667 16,25.5 L16,22 L15,22 L15,25.232 L13,26.566 L13,24 L12,24 L12,27.5 C12,27.667 12.084,27.823 12.223,27.916 L15.223,29.916 C15.307,29.972 15.403,30 15.5,30 C15.597,30 15.694,29.972 15.778,29.916 L18.777,27.916 C18.916,27.823 19,27.667 19,27.5 L19,24 L18,24 L18,27.232 Z M13,8 L12,8 L12,4.5 C12,4.333 12.084,4.177 12.223,4.084 L15.223,2.084 C15.391,1.972 15.61,1.972 15.778,2.084 L18.777,4.084 C18.916,4.177 19,4.333 19,4.5 L19,8 L18,8 L18,5.434 L16,6.767 L16,10 L15,10 L15,6.5 C15,6.333 15.084,6.177 15.223,6.084 L17.599,4.5 L15.5,3.101 L13,4.767 L13,8 Z",
    id: "AWS-ThinkBox-Mesh_32_Squid"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchAwsThinkboxXMesh32);
export default __webpack_public_path__ + "static/media/Arch_AWS-Thinkbox-XMesh_32.473ee0ba2dee6e4a8a1b69be7d5facfa.svg";
export { ForwardRef as ReactComponent };